import { render, staticRenderFns } from "./manage-product-category-likeables-modal.vue?vue&type=template&id=6e1cc67d&scoped=true&"
import script from "./manage-product-category-likeables-modal.vue?vue&type=script&lang=js&"
export * from "./manage-product-category-likeables-modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-product-category-likeables-modal.vue?vue&type=style&index=0&id=6e1cc67d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1cc67d",
  null
  
)

export default component.exports